export const discountEstimate = () => ({
  priceRule: null,
  variantId: null,
  sellingPlanId: null,
  priceRuleElement: null,
  redirectToCheckout: false,
  redirectToCart: false,
  discountCodes: null,
  priceRuleName: null,
  discountCodesOTP: null,
  discountCodesSUB: null,
  newSubscribersOnly: false,
  sub_free_gifts: [],
  otp_free_gifts: [],
  cart: null,
  isAdding: false,
 
  init() {
    this.variantId = this.$el.dataset.variantId;
    this.$nextTick(() => {
      this._parsePriceRuleData();
    });
  },
 
  // Set the cart reference
  setCart(cartElement) {
    this.cart = cartElement;
    return this; // For method chaining
  },
 
  _getPurchaseType() {
    const ordergrooveComponent = document.querySelector('.dsc-custom-ordergroove-ui');
    if (ordergrooveComponent) {
      const selectedOption = document.querySelector('input[name="dsc-custom-ordergroove-ui"]:checked');
      const type = selectedOption?.value === 'subscribe' ? 'subscription' : 'one_time';
      this.sellingPlanId = document.querySelector('#subscription-frequency')?.value;
      return type;
    }
    return 'one_time';
  },
 
  _parsePriceRuleData() {
    const priceRuleElement = this.$el?.querySelector('.discount-estimate-data');
    if (priceRuleElement) {
      try {
        const priceRuleJSON = JSON.parse(priceRuleElement.textContent);
        this.priceRule = priceRuleJSON;
        this.priceRuleName = this.priceRule.name;
        this.discountCodes = this.priceRule.discount_codes;
        this.discountCodesOTP = this.priceRule.otp_additional_codes || '';
        this.discountCodesSUB = this.priceRule.sub_additional_codes || '';
        this.newSubscribersOnly = this.priceRule.new_subscribers_only;
        this.redirectToCheckout = this.priceRule.is_checkout_redirect;
        this.redirectToCart = this.priceRule.is_cart_redirect;
        this.sub_free_gifts = this.priceRule.sub_free_gifts || [];
        this.otp_free_gifts = this.priceRule.otp_free_gifts || [];
      } catch (e) {
        console.error('Error parsing discount estimate JSON:', e);
      }
    }
  },
 
  async applyDiscountToCart(discountString) {
    return _applyDiscount.call(this, discountString);
  },
});

// Private function to contain the core logic
async function _applyDiscount(discountString) {
  if (!this.cart || !discountString) {
    throw new Error('debug Cart not initialized or missing discount string');
  }
  const body = {
    discount: discountString,
    sections: this.cart.getSectionsToRender().map((section) => section.id),
    sections_url: window.location.pathname
  };
  const response = await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify(body)
  }).then(response => {
    if(this.redirectToCheckout) {
      window.location.href = '/checkout';
      return;
    }
    if(this.redirectToCart) {
      window.location.href = '/cart';
      return;
    }
    return response.json();
  }).catch(error => {
    throw error;
  });

  return response;
}
 
// Export utility functions for direct usage
export const discountUtils = {
  async applyDiscountToCart(discountString, cartElement, discountEstimateElement) {
    const newInstance = discountEstimate();

    if (discountEstimateElement) {
      const existingInstanceData = discountEstimateElement._x_dataStack[0];
      // If there's no price rule on the element, there's nothing to do.
      if (!existingInstanceData.priceRule) {
        return cartElement ? cartElement.cart : null;
      }
      newInstance.priceRule = existingInstanceData.priceRule;
      newInstance.redirectToCheckout = existingInstanceData.redirectToCheckout;
      newInstance.redirectToCart = existingInstanceData.redirectToCart;
      newInstance.$el = discountEstimateElement;
    }

    newInstance.setCart(cartElement);
    return _applyDiscount.call(newInstance, discountString);
  },
 
  getCartPayload(mainVariantId, discountEstimateElement) {
    const instance = discountEstimate();
    const parentForm = discountEstimateElement?.closest('product-form') || document.querySelector(`product-form[data-variant-id="${mainVariantId}"]`);

    instance.$el = discountEstimateElement || parentForm;

    if (discountEstimateElement) {
      instance._parsePriceRuleData();
    }
    
    const quantity = document.querySelector('input[name="quantity"]')?.value || 1;
    let mainItem = { id: mainVariantId, quantity: parseInt(quantity) };

    const type = instance._getPurchaseType();

    // Create the main item and conditionally add the selling plan
    if (type === 'subscription' && instance.sellingPlanId) {
      mainItem.selling_plan = instance.sellingPlanId;
    }

    const items = [mainItem];

    if (!instance.priceRule) {
      return { items, discountString: '' };
    }

    let codes = [];

    const freeGifts = type === 'subscription' ? instance.sub_free_gifts : instance.otp_free_gifts;
    if (freeGifts && freeGifts.length > 0) {
      freeGifts.forEach(giftId => items.push({ id: giftId, quantity: 1 }));
    }


    if (instance.discountCodes) {
      codes.push(instance.discountCodes);
    }

    const additionalCodes = type === 'subscription' ? instance.discountCodesSUB : instance.discountCodesOTP;
    if (additionalCodes) {
      codes.push(additionalCodes);
    }

    const discountString = codes.filter(c => c).join(',');
    return { items, discountString };
  }
};